export const ca_main_categories = [
  {
    to: "/v1/dashboard-ca",
    icon: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6",
    label: "Dashboard",
    submenu: [],
    role: "CHURCH_ADMIN",
  },
  {
    to: "/venues",
    icon: "M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4",
    label: "Venues",
    submenu: [],
    role: "CHURCH_ADMIN",
  },
  {
    to: "/events",
    icon: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z",
    label: "Manage Events",
    submenu: [],
    role: "CHURCH_ADMIN",
  },
  {
    to: "/events-calender",
    icon: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z",
    label: "Events Calender",
    submenu: [],
    role: "CHURCH_ADMIN",
  },
  {
    to: "/sponsor-list",
    icon: "M13 7h8m0 0v8m0-8l-8 8-4-4-6 6",
    label: "Sponsors List",
    submenu: [],
    role: "CHURCH_ADMIN",
  },
  {
    to: "/churchonboard",
    icon: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6",
    label: "Dashboard",
    submenu: [],
    role: "FULL_ACCESS",
  },
  {
    to: "/master",
    icon: "M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4",
    label: "Master",
    submenu: [
      {
        to: "/assets",
        icon: "M13 10V3L4 14h7v7l9-11h-7z",
        label: "Assets Masters",
      },
      {
        to: "/baptism/list",
        icon: "M13 10V3L4 14h7v7l9-11h-7z",
        label: "Baptism Register",
      },
      {
        to: "/worship/list",
        icon: "M5 3a2 2 0 012-2h10a2 2 0 012 2v14a2 2 0 01-2 2H7a2 2 0 01-2-2V3z",
        label: "Worship Register",
      },
      {
        to: "/marriages/list",
        icon: "M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z",
        label: "Marriage Register",
      },
      {
        to: "/confirmation/list",
        icon: "M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z",
        label: "Confirmation Register",
      },
      {
        to: "/burial/list",
        icon: "M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4",
        label: "Burial Register",
      },
    ],
    role: "CHURCH_ADMIN",
  },
  {
    to: "#",
    icon: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z",
    label: "Transactions",
    submenu: [
      {
        to: "/assets/inventory",
        icon: "M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z",
        label: "Asset Management",
      },
      {
        to: "/income",
        icon: "M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z",
        label: "Income Management",
      },
      {
        to: "/expenses",
        icon: "M9 14l6-6m-5.5.5h.01m4.99 5h.01M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16l3.5-2 3.5 2 3.5-2 3.5 2zM10 8.5a.5.5 0 11-1 0 .5.5 0 011 0zm5 5a.5.5 0 11-1 0 .5.5 0 011 0z",
        label: "Expense Management",
      },
      {
        to: "/salaries",
        icon: "M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z",
        label: "Salary Management",
      },
      {
        to: "/dues-income",
        icon: "M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z",
        label: "Dues Management",
      },
    ],
    role: "CHURCH_ADMIN",
  },
  {
    to: "/catlist",
    icon: "M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zm10 0a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zm10 0a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z",
    label: "Category Master",
    submenu: [],
    role: "CHURCH_ADMIN",
  },
  {
    to: "/employees",
    icon: "M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z",
    label: "Employee / Volunteer",
    submenu: [],
    role: "CHURCH_ADMIN",
  },
  {
    to: "/banks",
    icon: "M4 4a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2H4zm0 2h12v12H4V6zm3 3a1 1 0 011-1h4a1 1 0 110 2H8a1 1 0 01-1-1zm0 4a1 1 0 011-1h4a1 1 0 110 2H8a1 1 0 01-1-1z",
    label: "Banks",
    submenu: [],
    role: "CHURCH_ADMIN",
  },
  {
    to: "/notices",
    icon: "M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9",
    label: "Member Notice",
    submenu: [],
    role: "CHURCH_ADMIN",
  },
  {
    to: "/newsletters",
    icon: "M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z",
    label: "Member Newsletter",
    submenu: [],
    role: "CHURCH_ADMIN",
  },
  {
    to: "/#",
    icon: "M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z",
    label: "Reports",
    submenu: [
      {
        to: "/reports/income",
        icon: "M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z",
        label: "Income Reports",
      },
      {
        to: "/reports/income/flexi",
        icon: "M9 14l6-6m-5.5.5h.01m4.99 5h.01M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16l3.5-2 3.5 2 3.5-2 3.5 2zM10 8.5a.5.5 0 11-1 0 .5.5 0 011 0zm5 5a.5.5 0 11-1 0 .5.5 0 011 0z",
        label: "Income Flexi Reports",
      },
      {
        to: "/reports/expense",
        icon: "M9 14l6-6m-5.5.5h.01m4.99 5h.01M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16l3.5-2 3.5 2 3.5-2 3.5 2zM10 8.5a.5.5 0 11-1 0 .5.5 0 011 0zm5 5a.5.5 0 11-1 0 .5.5 0 011 0z",
        label: "Expense Reports",
      },
      {
        to: "/reports/expense/flexi",
        icon: "M9 14l6-6m-5.5.5h.01m4.99 5h.01M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16l3.5-2 3.5 2 3.5-2 3.5 2zM10 8.5a.5.5 0 11-1 0 .5.5 0 011 0zm5 5a.5.5 0 11-1 0 .5.5 0 011 0z",
        label: "Expense Flexi Reports",
      },
      {
        to: "/monthly/statements",
        icon: "M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z",
        label: "Monthly Statements",
      },
      {
        to: "/yearly/statement",
        icon: "M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z",
        label: "Yearly Statement",
      },
      {
        to: "/reports/events",
        icon: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z",
        label: "Event Reports",
      },
      {
        to: "/reports/event/flexi",
        icon: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z",
        label: "Event Flexi Reports",
      },
      {
        to: "/reports/employee",
        icon: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z",
        label: "Employee Reports",
      },
      {
        to: "/reports/family/flexi",
        icon: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z",
        label: "Family Flexi Reports",
      },
    ],
    role: "CHURCH_ADMIN",
  },
  {
    to: "/families",
    icon: "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z",
    label: "Family Register",
    submenu: [],
    role: "CHURCH_ADMIN",
  },
  {
    to: "/church-subscribers",
    icon: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z",
    label: "Church Subscribers",
    submenu: [],
    role: "CHURCH_ADMIN",
  },
  {
    to: "/member/dashboard",
    icon: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6",
    label: "Dashboard",
    submenu: [],
    role: "CHURCH_MEMBER",
  },
  {
    to: "/memberNotices",
    icon: "M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9",
    label: "Member Notices",
    submenu: [],
    role: "CHURCH_MEMBER",
  },
  {
    to: "/events-calender",
    icon: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z",
    label: "Calender",
    submenu: [],
    role: "CHURCH_MEMBER",
  },
  {
    to: "/memberEvents",
    icon: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z",
    label: "Member Events",
    submenu: [],
    role: "CHURCH_MEMBER",
  },
  {
    to: "/member/public-events",
    icon: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z",
    label: "Public Events",
    submenu: [],
    role: "CHURCH_MEMBER",
  },

  {
    to: "/memberNewsletters",
    icon: "M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z",
    label: "Newsletters",
    submenu: [],
    role: "CHURCH_MEMBER",
  },
  {
    to: "/member/payments",
    icon: "M9.25 4.75v3.5a.75.75 0 01-.75.75H4.75v7.5a2 2 0 002 2h10.5a2 2 0 002-2v-7.5h-3.75a.75.75 0 01-.75-.75v-3.5h-5.5zM9.75 3.5h4.5v3.25h3.75a.75.75 0 01.75.75v8a3.5 3.5 0 01-3.5 3.5H6.75a3.5 3.5 0 01-3.5-3.5v-8a.75.75 0 01.75-.75h3.75V3.5zm-1.5 10a.75.75 0 000 1.5h3.5a.75.75 0 000-1.5h-3.5z",
    label: "Subscription",
    submenu: [],
    role: "CHURCH_MEMBER",
  },
  // {
  //   to: "/member-other/payments",
  //   icon: "M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z",
  //   label: "Other Payments",
  //   submenu: [],
  //   role: "CHURCH_MEMBER",
  // },

  {
    to: "/member/families",
    icon: "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z",
    label: "Families",
    submenu: [],
    role: "CHURCH_MEMBER",
  },
  //sub member
  {
    to: "/member/dashboard",
    icon: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6",
    label: "Dashboard",
    submenu: [],
    role: "SUB_MEMBER",
  },
  {
    to: "/memberNotices",
    icon: "M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9",
    label: "Member Notices",
    submenu: [],
    role: "SUB_MEMBER",
  },
  {
    to: "/memberEvents",
    icon: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z",
    label: "Member Events",
    submenu: [],
    role: "SUB_MEMBER",
  },
  {
    to: "/memberNewsletters",
    icon: "M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z",
    label: "Newsletters",
    submenu: [],
    role: "SUB_MEMBER",
  },
  {
    to: "/member/payments",
    icon: "M9.25 4.75v3.5a.75.75 0 01-.75.75H4.75v7.5a2 2 0 002 2h10.5a2 2 0 002-2v-7.5h-3.75a.75.75 0 01-.75-.75v-3.5h-5.5zM9.75 3.5h4.5v3.25h3.75a.75.75 0 01.75.75v8a3.5 3.5 0 01-3.5 3.5H6.75a3.5 3.5 0 01-3.5-3.5v-8a.75.75 0 01.75-.75h3.75V3.5zm-1.5 10a.75.75 0 000 1.5h3.5a.75.75 0 000-1.5h-3.5z",
    label: "Subscription",
    submenu: [],
    role: "SUB_MEMBER",
  },
  // {
  //   to: "/member-other/payments",
  //   icon: "M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z",
  //   label: "Other Payments",
  //   submenu: [],
  //   role: "SUB_MEMBER",
  // },
  {
    to: "/member/public-events",
    icon: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z",
    label: "Public Events",
    submenu: [],
    role: "SUB_MEMBER",
  },
  {
    to: "/events-calender",
    icon: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z",
    label: "Calender",
    submenu: [],
    role: "SUB_MEMBER",
  },
  {
    to: "/member/families",
    icon: "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z",
    label: "Families",
    submenu: [],
    role: "SUB_MEMBER",
  },
];

export const main_admin_categories = [
  {
    to: "/financials",
    icon: "M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z",
    label: "Financial Year",
    submenu: [],
    role: "CHURCH_ADMIN",
  },
  {
    to: "/churches",
    icon: "M19 21v-2a4 4 0 00-4-4H9a4 4 0 00-4 4v2m4-10a4 4 0 110-8 4 4 0 010 8zm0 0c1.306 0 2.417.835 2.83 2M9 11a4 4 0 11-8 0 4 4 0 018 0zm10 0a4 4 0 11-8 0 4 4 0 018 0z",
    label: "Church List",
    submenu: [],
    role: "CHURCH_ADMIN",
  },
  {
    to: "/dioceseslist",
    icon: "M3 21v-4m0 0V5a2 2 0 012-2h6.5l1 1H21l-3 6 3 6h-8.5l-1-1H5a2 2 0 00-2 2zm9-13.5V9",
    label: "Diocese List",
    submenu: [],
    role: "CHURCH_ADMIN",
  },
  {
    to: "/users",
    icon: "M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z",
    label: "Users Management",
    submenu: [],
    role: "CHURCH_ADMIN",
  },
  {
    to: "/roles",
    icon: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01",
    label: "Roles List",
    submenu: [],
    role: "CHURCH_ADMIN",
  },
];
